<template>
    <div class="card">
        <div class="card-header p-2">
            <div class="row">
                <div class="col-md-10">
                    <!-- <strong class="card-title mb-3">{{ 'Users List' }}</strong> -->
                </div>
                <div class="col-md-1">
                    <!-- <download :tableId="'users'" :fileName="'users-list'"></download> -->
                </div>
                <div class="col-md-1">
                    <goback></goback>
                </div>
            </div>
        </div>
        <vue-tabs direction="horizontal" @tab-change="getTabData" active-text-color="black">
            <v-tab title="Risk Profiling">
                <div class="card txt-fmt" id="investorRiskProfiling">
                    <form class="form-horizontal" style="margin-left: 5px;">

                        <div style="display: flex;justify-content: center;margin-top: 8px;">
                            <button type="button" @click="showNewInvestorProfilingMasterData"
                                class="btn btn-sm mb5 btn-primary" style="padding: 0.2rem;">New Question Type</button>
                        </div>
                        <div v-if="isShow" class="d-flex flex-row align-items-center border p-2 mt-2 mb-2 strategy-edit"
                            style="padding-bottom: 0 !important;">
                            <label for="stock-query-txt" class="col-form-label mr-2">{{ isNew ? "New:" : "Edit:"
                                }}</label>
                            <!-- NEW -->
                            <div class="col-md-1 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Risk Need:<v-select :options="riskNeedOpt" :placeholder="'Risk Need'"
                                    v-model="editInvestorRiskProfilingMasterData.risk_need">
                                </v-select>
                            </div>

                            <div class="col-md-1 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Risk Taking:<v-select :options="riskTakingAbilityOpt" :placeholder="'Risk Taking'"
                                    v-model="editInvestorRiskProfilingMasterData.risk_taking_ability">
                                </v-select>
                            </div>

                            <div
                                class="col-md-1 new-cal-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Behavioral Loss Tolerance:<v-select :options="behavioralLossToleranceOpt"
                                    :placeholder="'Behavioral Loss Tolerance'"
                                    v-model="editInvestorRiskProfilingMasterData.behavioral_loss_tolerance">
                                </v-select>
                            </div>
                            <div
                                class="col-md-2 new-cal-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">

                                Green/Yellow/Red Light :<v-select :options="green_yellow_red_lightOpt"
                                    :placeholder="'Green/Yellow/Red Light'"
                                    v-model="editInvestorRiskProfilingMasterData.green_yellow_red_light">
                                </v-select>
                            </div>
                            <div class="col-md-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Recommendation:<textarea v-model="editInvestorRiskProfilingMasterData.recommendation"
                                    rows="2" cols="50" placeholder="" class="txt-area"></textarea>
                            </div>


                            <div class="col-md-3 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                Strategy:<textarea v-model="editInvestorRiskProfilingMasterData.strategy" rows="2"
                                    cols="50" placeholder="" class="txt-area"></textarea>
                            </div>

                            <!-- NEW -->
                            <div class="d-flex align-items-center mr-3 pl-1">
                                <button type="button" @click="submitInvestorRiskProfilingMasterData"
                                    class="btn btn-sm btn-primary" style="padding: 0.2rem;">Submit</button>
                            </div>
                        </div>
                        <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
                        <div class="card-body pt-0">
                            <div class="d-flex justify-content-start flex-wrap">
                                <div class="col-md-12 pr-2 pl-0 d-flex justify-content-start"
                                    v-for="(row, index) in investorRiskProfilingMasterData"
                                    v-bind:key="'invest' + index">
                                    <div class="col-md-1 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Risk Need:<v-select :options="riskNeedOpt" :placeholder="'Risk Need'"
                                                v-model="row.risk_need">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-1 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Risk Taking:<v-select :options="riskTakingAbilityOpt"
                                                :placeholder="'Risk Taking'" v-model="row.risk_taking_ability">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Behavioral Loss Tolerance:<v-select :options="behavioralLossToleranceOpt"
                                                :placeholder="'Behavioral Loss Tolerance'"
                                                v-model="row.behavioral_loss_tolerance">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Green/Yellow/Red Light :<v-select :options="green_yellow_red_lightOpt"
                                                :placeholder="'Green/Yellow/Red Light'"
                                                v-model="row.green_yellow_red_light">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Recommendation:<textarea v-model="row.recommendation" rows="2" cols="50"
                                                placeholder="" class="txt-area"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-3 pr-2 pl-0">
                                        <div class="form-group text-end d-flex align-items-center flex-wrap">
                                            Strategy:<textarea v-model="row.strategy" rows="2" cols="50" placeholder=""
                                                class="txt-area"></textarea>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column justify-content-center pl-1"
                                        style="margin-left: -0.45rem !important;">
                                        <a class="btn btn-sm btn-small btn-primary"
                                            @click.prevent="editInvestorRiskProfilingMasterClick(row)"
                                            style="margin: 4px;">
                                            <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                        </a>
                                        <a class="btn btn-sm btn-small btn-danger"
                                            @click="removeInvestorRiskProfilingMasterClick(row)" style="margin: 4px;"><i
                                                title="Delete Row" class="fa fa-trash cwhite"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </v-tab>
            <v-tab title="Portfolio Allocation Calculation Limit">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Form for portfolio allocation
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getCalculationLimitAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="calculationLimitTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in calculationLimitLblData" :key="index"
                                        :style="[item.field === 'risk_limits' ? { 'width': '40%' } : item.field === 'Category' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in calculationLimitTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in calculationLimitLblData" :key="subIdx">
                                        <input
                                            v-if="itemLbl.field == 'risk_limits' || itemLbl.field == 'low' || itemLbl.field == 'mod_low' || itemLbl.field == 'moderate' || itemLbl.field == 'mod_high' || itemLbl.field == 'high'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeCalculationLimitData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addCalculationLimitData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitCalculationLimitAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Desired Asset Allocation (Client)">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Desired Asset Allocation (Client)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getDesireAssetAllocationAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="desireAssetAllocationTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in desireAssetAllocationLblData" :key="index"
                                        :style="[item.field === 'desired_asset_field' ? { 'width': '40%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in desireAssetAllocationTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in desireAssetAllocationLblData" :key="subIdx">
                                        <input v-if="itemLbl.field == 'desired_asset_field' || itemLbl.field == '%_Mix'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeDesireAssetAllocationData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addDesireAssetAllocationData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitDesireAssetAllocationAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Alternatives Desired Mix">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Alternatives Desired Mix
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getDesiredMixAlternativesAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="desiredMixAlternativesTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in desiredMixAlternativesLblData" :key="index"
                                        :style="[item.field === 'desired_asset_field' ? { 'width': '40%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in desiredMixAlternativesTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in desiredMixAlternativesLblData" :key="subIdx">
                                        <input v-if="itemLbl.field == 'desired_asset_field' || itemLbl.field == '%_Mix'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeDesiredMixAlternativesData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addDesiredMixAlternativesData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitDesiredMixAlternativesAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Portfolio Allocation Asset Class">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Form for Portfolio Allocation Asset Class
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAssetClassAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="assetClassTblData.length > 0" class="table-responsive scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in assetClassLblData" :key="index"
                                        :style="[item.field === 'asset_class_field' ? { 'width': '40%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in assetClassTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in assetClassLblData" :key="subIdx">
                                        <input class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <!-- <label v-else>{{ key[itemLbl.field] }}</label> -->
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAssetClassData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAssetClassData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAssetClassAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Asset Class Outlook And Action">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Asset Class Outlook And Action
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getOutlookAndActionAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="outlookAndActionTblData.length > 0" class="table-responsive scrollbar app"
                        style="padding-bottom:4rem" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner mb-6">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in outlookAndActionLblData" :key="index"
                                        :style="[item.field === 'asset_class_field' ? { 'width': '40%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in outlookAndActionTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in outlookAndActionLblData" :key="subIdx">
                                        <v-select v-if="itemLbl.field === 'outlook'" :placeholder="'Outlook'"
                                            :options="assetClassOutlookList" v-model="key[itemLbl.field]">
                                        </v-select>
                                        <v-select v-else-if="itemLbl.field === 'action'" :placeholder="'Action'"
                                            :options="assetClassActionList" v-model="key[itemLbl.field]">
                                        </v-select>
                                        <input v-else class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <!-- <div
                                            class="col-md-2 new-cal-2 pr-2 pl-0 form-group text-end d-flex align-items-center flex-wrap">
                                            Risk Need:<v-select :options="riskNeedOpt" :placeholder="'Risk Need'"
                                                v-model="editInvestorRiskProfilingMasterData.risk_need">
                                            </v-select>
                                        </div> -->
                                        <!-- <label v-else>{{ key[itemLbl.field] }}</label> -->
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeOutlookAndActionData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addOutlookAndActionData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitOutlookAndActionAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Portfolio Allocation Alternatives-INR">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Portfolio Allocation Alternatives-INR
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAlternativesInrAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="allocationAlternativesInrTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in allocationAlternativesInrLblData" :key="index"
                                        :style="[item.field === 'asset_class_field' ? { 'width': '40%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in allocationAlternativesInrTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in allocationAlternativesInrLblData" :key="subIdx">
                                        <input class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAlternativesInrData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAlternativesInrData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAlternativesInrAPI">Submit</button>
                    </div>
                </div>
            </v-tab>
            <v-tab title="Hybrid Bifurcation">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Hybrid Bifurcation
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getHybridBifurcationAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="hybridBifurcationTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in hybridBifurcationLblData" :key="index"
                                        :style="[item.field === 'field_name' ? { 'width': '40%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in hybridBifurcationTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in hybridBifurcationLblData" :key="subIdx">
                                        <input class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeHybridBifurcationData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addHybridBifurcationData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitHybridBifurcationAPI">Submit</button>
                    </div>
                </div>
            </v-tab>

            <!-- <v-tab title="Interpretation Of Results">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Interpretation of Results
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getInterpretationResultAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="interpretationResultTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in interpretationResultLblData" :key="index">{{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in interpretationResultTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in interpretationResultLblData" :key="subIdx">
                                        <textarea v-if="itemLbl.field == 'descriptions'" v-model="key[itemLbl.field]"
                                            rows="3" cols="50" placeholder="" class="txt-area"></textarea>
                                        <input v-else class="new-tbl-cs" type="text"
                                            v-model="key[itemLbl.field]"></input>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeInterpretationResultData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addInterpretationResultData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitInterpretationResultAPI">Submit</button>
                    </div>
                </div>
            </v-tab> -->
            <!-- <v-tab title="Assumptions & Asset Allocation Framework">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Assumptions & Asset Allocation (AAA) Framework
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAAFrameworkAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaFrameworkTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaFrameworkLblData" :key="index"
                                        :style="[item.field === 'input_value' ? { 'width': '12%' } : item.field === 'sub_category' ? { 'width': '40%' } : item.field === 'S_No' ? { 'width': '10%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaFrameworkTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaFrameworkLblData" :key="subIdx">
                                        <div v-if="itemLbl.field == 'sub_category' || itemLbl.field == 'input_value'"
                                            class="">
                                            <div v-for="(subCatItem, cIdx) in key.data" class="d-flex">
                                                <input class="new-tbl-aaa-cs" :key="cIdx"
                                                    v-model="subCatItem[itemLbl.field]" />
                                                <div v-if="itemLbl.field == 'sub_category'"
                                                    @click="removeSubCategoryData(key.data, cIdx)">
                                                    <a class="btn btn-sm btn-small btn-danger mt-2"
                                                        style="margin: 4px 4px;"><i title="Delete Row"
                                                            class="fa fa-trash cwhite"></i></a>
                                                </div>
                                            </div>
                                            <div>
                                                <button v-if="itemLbl.field == 'sub_category'" class="btn-success"
                                                    style="border: none;" type="button"
                                                    @click="addSubCategoryData(key.data)"><i
                                                        class="fa fa-plus"></i></button>
                                            </div>
                                        </div>
                                        <input v-else class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAAFrameworkData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAAFrameworkData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAAAFrameworkAPI">Submit</button>
                    </div>
                </div>
            </v-tab> -->
            <!-- <v-tab title="Asset Allocation Assumptions Time Horizon">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Asset Allocation Assumptions (Based on Time Horizon of Goal)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAATimeHorizonAPI"><i title="Reload Data"
                                    class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaTimeHorizonTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaTimeHorizonLblData" :key="index"
                                        :style="[item.field === 'Description' ? { 'width': '40%' } : item.field === 'Category' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaTimeHorizonTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaTimeHorizonLblData" :key="subIdx">
                                        <input v-if="itemLbl.field == 'Category' || itemLbl.field == 'Description'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAATimeHorizonData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAATimeHorizonData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAAATimeHorizonAPI">Submit</button>
                    </div>
                </div>
            </v-tab> -->
            <!-- <v-tab title="Asset Allocation Assumptions Risk Profile">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Asset Allocation Assumptions (Based on Risk Profile of Client)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAARiskProfileOfClientAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaRiskProfileOfClientTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaRiskProfileOfClientLblData" :key="index"
                                        :style="[item.field === 'Type_of_Investor' ? { 'width': '40%' } : item.field === 'Risk_Profile' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaRiskProfileOfClientTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaRiskProfileOfClientLblData" :key="subIdx">
                                        <input
                                            v-if="itemLbl.field == 'Risk_Profile' || itemLbl.field == 'Type_of_Investor'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAARiskProfileOfClientData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAARiskProfileOfClientData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitAAARiskProfileOfClientAPI">Submit</button>
                    </div>
                </div>
            </v-tab> -->
            <!-- <v-tab title="Asset Allocation Assumptions Income Generation">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Asset Allocation Assumptions (Income Generation Requirement)
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getAAAIncomeGenerationAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaIncomeGenerationTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaIncomeGenerationLblData" :key="index"
                                        :style="[item.field === 'When' ? { 'width': '40%' } : item.field === 'Type_of_Corpus' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaIncomeGenerationTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaIncomeGenerationLblData" :key="subIdx">
                                        <input v-if="itemLbl.field == 'Type_of_Corpus' || itemLbl.field == 'When'"
                                            class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeAAAIncomeGenerationData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addAAAIncomeGenerationData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info" @click="submitAAAIncomeGenerationAPI">Submit</button>
                    </div>
                </div>
            </v-tab> -->
            <!-- <v-tab title="Professionals Recommendation to Client">
                <div class="card-body">
                    <div class="row mb5 d-flex">
                        <div class="col-md-6">
                            Professional's Recommendation to Client
                        </div>
                        <div class="col-md-6 text-right pr-5">
                            <div class="btn btn-primary btn-sm" @click="getRecommendationToClientAPI"><i
                                    title="Reload Data" class="fa fa-refresh"></i></div>
                        </div>
                    </div>
                    <div v-if="aaaRecommendationToClientTblData.length > 0" class="table-responsive scrollbar app"
                        v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                            <thead>
                                <tr>
                                    <th v-for="(item, index) in aaaRecommendationToClientLblData" :key="index"
                                        :style="[item.field === 'Investment_Portfolio_Name' ? { 'width': '50%' } : item.field === 'S_No' ? { 'width': '8%' } : { 'width': 'auto' }]">
                                        {{ item.lbl }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(key, index) in aaaRecommendationToClientTblData[0].data" :key="index">
                                    <td v-for="(itemLbl, subIdx) in aaaRecommendationToClientLblData" :key="subIdx">
                                        <input v-if="itemLbl.field == 'Investment_Portfolio_Name'" class="new-tbl-cs"
                                            type="text" v-model="key[itemLbl.field]" />
                                        <label v-else>{{ key[itemLbl.field] }}</label>
                                    </td>
                                    <a class="btn btn-sm btn-small btn-danger mt-2" style="margin: 4px 4px;"
                                        @click="removeRecommendationToClientData(index)"><i title="Delete Row"
                                            class="fa fa-trash cwhite"></i></a>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group d-flex justify-content-between">
                        <button class="btn btn-sm btn-success" type="button" @click="addRecommendationToClientData"><i
                                class="fa fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-info"
                            @click="submitRecommendationToClientAPI">Submit</button>
                    </div>
                </div>
            </v-tab> -->
        </vue-tabs>
    </div>
</template>
<script>
import http from "@/lib/http";
//import { commonMixins } from "../../assets/mixins/common.js";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;

export default {
    props: ["onCreated"],
    //components: { PinCheck },
    name: "ProfilingAllocationForm",
    created() {
        console.log("Created ::: edit id", this.$route.params);
        //this.getStrategyMasterData();
        this.getInvestorRiskProfiling();
    },
    watch: {
        onCreated(flg) {
            console.log('created:', flg);
            this.getStrategyMasterData();
        }
    },
    data() {
        return {
            isNew: false,
            isShow: false,
            calculationFormulaData: ["<", ">", "<=", ">=", "==", "!="],
            editStrategyMasterData: { "strategy_title": "" },
            editCategoryMasterData: { "strategy_category": "" },
            editQuestionTypeMasterData: { "question_type": "", "response_list": [] },
            editResponseTitleMasterData: { "response_title": "" },
            editInvestorRiskProfilingMasterData: {
                "behavioral_loss_tolerance": null,
                "risk_need": null,
                "risk_taking_ability": null,
                "green_yellow_red_light": null,
                "recommendation": "",
                "strategy": ""
            },
            retirementFormData: [{ "data": [] }],
            strategyBenchmarkMasterData: [{ "data": [] }],
            strategyMasterData: [],
            categoryMasterData: [],
            questionTypeMasterData: [],
            responseTitleMasterData: [],
            selectedStrategyQuestionCategory: null,
            strategyQueObject: {
                "strategy_category": "",
                "strategy_title": "",
                "data": []
            },
            errors: [],
            strategyQueChildObj: [{
                "title": "",
                "type": "",
                "answer": "",
                "strategy_benchmark": []
            }],
            selectedStrategyTitleItem: null,
            selectedCategoryItem: null,
            investorRiskProfilingMasterData: [],
            riskNeedOpt: ["High", "Mod", "Low"],
            riskTakingAbilityOpt: ["High", "Mod", "Low"],
            behavioralLossToleranceOpt: ["High", "Mod", "Low"],
            green_yellow_red_lightOpt: ["Green Light", "Yellow Light", "Red Light"],
            assetClassOutlookList: ["Positive", "Negative", "Neutral"],
            assetClassActionList: ["Overweight", "Underweight", "Neutral"],

            aaaIncomeGenerationLblData: [
                { lbl: "S No.", field: "S_No" },
                { lbl: "Type of Corpus", field: "Type_of_Corpus" },
                { lbl: "When", field: "When" },
                { lbl: "Liquid", field: "Liquid" },
                { lbl: "Debt", field: "Debt" },
                { lbl: "Gold", field: "Gold" },
                { lbl: "Equity", field: "Equity" },
                { lbl: "Total", field: "Total" },
                { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
            ],
            aaaIncomeGenerationTblData: [],
            calculationLimitLblData: [
                { lbl: "Risk-limits", field: "risk_limits" },
                { lbl: "Low", field: "low" },
                { lbl: "Mod Low", field: "mod_low" },
                { lbl: "Moderate", field: "moderate" },
                { lbl: "Mod High", field: "mod_high" },
                { lbl: "High", field: "high" },
            ],
            calculationLimitTblData: [],

            assetClassLblData: [
                { lbl: "Asset Class:", field: "asset_class_field" },
                { lbl: "INR", field: "INR" },
                { lbl: "%", field: "persentage" },
                { lbl: "Investment horizon (years)", field: "investment_horizon_years" },
            ],
            assetClassTblData: [],
            outlookAndActionLblData: [
                { lbl: "Asset class outlook and action:", field: "field_name" },
                { lbl: "Outlook", field: "outlook" },
                { lbl: "Action", field: "action" },
                { lbl: "Rationale", field: "rationale" },
            ],
            outlookAndActionTblData: [],
            hybridBifurcationLblData: [
                { lbl: "Name", field: "field_name" },
                { lbl: "Value", field: "value" }
            ],
            hybridBifurcationTblData: [],
            allocationAlternativesInrLblData: [
                { lbl: "Alternatives", field: "asset_class_field" },
                { lbl: "INR", field: "INR" },
                { lbl: "%", field: "persentage" }
            ],
            allocationAlternativesInrTblData: [],

            desireAssetAllocationLblData: [
                { lbl: "Desired Asset Allocation (Client)", field: "desired_asset_field" },
                { lbl: "Desired Mix %", field: "%_Mix" }
            ],
            desireAssetAllocationTblData: [],
            desiredMixAlternativesLblData: [
                { lbl: "Alternatives", field: "desired_asset_field" },
                { lbl: "Desired Mix %", field: "%_Mix" }
            ],
            desiredMixAlternativesTblData: [],
        };
    },
    methods: {
        Validator() {
            return Validator.create();
        },
        /* updateStrategyTitleKeyValue(event) {
            console.log('1=> ', this.selectedStrategyTitleItem, this.selectedCategoryItem);
            this.strategyQueObject["strategy_category"] = this.selectedCategoryItem == null ? "" : this.selectedCategoryItem.strategy_category;
            this.strategyQueObject["strategy_title"] = this.selectedStrategyTitleItem == null ? "" : this.selectedStrategyTitleItem.strategy_title;
            this.getConversationsFormData();
        }, */
        /* updateStrategyCategoryKeyValue(event) {
            this.strategyQueObject["strategy_category"] = this.selectedCategoryItem == null ? "" : this.selectedCategoryItem.strategy_category;
            this.strategyQueObject["strategy_title"] = this.selectedStrategyTitleItem == null ? "" : this.selectedStrategyTitleItem.strategy_title;
            this.getConversationsFormData();
        }, */
        addConversationsFormData() {
            this.strategyQueObject.data.push({
                "title": "",
                "type": "",
                "answer": "",
                "strategy_benchmark": []
            });
        },
        /* submitConversationsFormData() {

            console.log('strategyQueObject   ::', this.strategyQueObject);
            if (this.strategyQueObject["strategy_category"] == "" || this.strategyQueObject["strategy_title"] == "") {
                this.$toastr.error("Please Select `Strategy Title` and `Category` form list", "", {});
                return;
            }
            let notValid = false;
            this.strategyQueObject.data.map((item) => {
                //console.log('###=> ', item.title, item.type)
                if (item.title == "" || item.type == "") {
                    //console.log('Not Valid');
                    notValid = true;
                }
            });
            if (notValid) {
                this.$toastr.error("Please fill the form proper !", "", {});
                return;
            }

            let self = this;
            http.post("/frontend/strategy_question/update", this.strategyQueObject, (error, response) => {
                if (response.responseType === 'success') {
                    self.$toastr.success(response.msg, "", {});
                }
            });
        }, */
        /* getStrategyData() {
            let self = this;
            http.get("/frontend/strategy_columns/get?type=super_admin", {}, (error, response) => {
                if (response.status === 'success') {
                    self.retirementFormData = response.data;
                }
            });
        }, */
        getStrategyMasterData() {
            let self = this;
            http.get("/frontend/strategy/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.strategyMasterData = response.data;
                }
            });
        },
        /*getCategoryMasterData() {
            let self = this;
            http.get("/frontend/strategy_category/get?type=super_admin", {}, (error, response) => {
                if (response.status === 'success') {
                    self.categoryMasterData = response.data;
                }
            });
        },
         submitCategoryMasterData() {
            let self = this;
            if (this.editCategoryMasterData.strategy_category.trim() === "") {
                this.$toastr.error("Category string not blank", "", {});
            } else {
                http.post("/frontend/strategy_category/update", this.editCategoryMasterData, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getCategoryMasterData();
                    }
                    self.editCategoryMasterData = { strategy_category: "" };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        }, */
        /* getResponseTitleMasterData() {
            let self = this;
            http.get("/frontend/response_title/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.responseTitleMasterData = response.data;
                }
            });
        }, */
        selectResponseTitleData() {
            console.log("Get RawData", this.selComp);
            /* if (this.selComp !== "") {
                localStorage.setItem("selcomp", JSON.stringify(this.selComp));
                this.company.companyname = this.selComp.companyname;
                this.company.co_code = this.selComp.co_code;
                console.log(
                    "Company",
                    this.company.co_code,
                    "=>",
                    this.company.companyname
                );
                // this.getTabData(this.selRowInd, {}, {});
                this.getRawData();
            } */
        },
        /* submitResponseTitleMasterData() {
            let self = this;
            if (this.editResponseTitleMasterData.response_title.trim() === "") {
                this.$toastr.error("Response Title string not blank", "", {});
            } else {
                http.post("/frontend/response_title/update", this.editResponseTitleMasterData, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getResponseTitleMasterData();
                    }
                    self.editResponseTitleMasterData = { response_title: "" };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        }, */
        /* getQuestionTypeMasterData() {
            let self = this;
            http.get("/frontend/question_type/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.questionTypeMasterData = response.data;
                    self.getResponseTitleMasterData();
                }
            });
        }, */
        /* submitQuestionTypeMasterData() {
            let self = this;
            if (this.editQuestionTypeMasterData.question_type.trim() === "") {
                this.$toastr.error("Question title string not blank", "", {});
            } else {
                //console.log('editQuestionTypeMasterData >>> ', this.editQuestionTypeMasterData);
                //return;
                http.post("/frontend/question_type/update", this.editQuestionTypeMasterData, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getQuestionTypeMasterData();
                    }
                    self.editQuestionTypeMasterData = { question_type: "", response_list: [] };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        }, */
        /* addStrategyBenchmarkMasterDataHandler() {
            this.strategyBenchmarkMasterData[0].data.push({
                "title": "",
                "type": "input",
                "response_list": [],
                "answer": "",
                "user_field": "",
                "user_field_enterd_valued": "",
                "calculation_formula": []
            })
        }, */
        /*  removeStrategyBenchmarkMasterDataHandler(idx) {
             this.strategyBenchmarkMasterData[0].data.splice(idx, 1);
         }, */
        /* getStrategyBenchmarkMasterData() {
            let self = this;
            http.get("/frontend/strategy_benchmark/get?type=super_admin", {}, (error, response) => {
                if (response.status === 'success') {
                    self.strategyBenchmarkMasterData = response.data;
                    self.getStrategyData();
                }
            });
        }, */
        /* submitStrategyBenchmarkMasterData() {
            let self = this;
            const collectStrategyBenchmarkData = this.strategyBenchmarkMasterData[0].data.map((item) => {
                let collectItemsData = item;
                //return [{ ...item, user_field: item.user_field.title }];
                collectItemsData.user_field = item.user_field.title;
                return collectItemsData;
            });
            //console.log('collectStrategyBenchmarkData: ', collectStrategyBenchmarkData)
            //return;
            http.post("/frontend/strategy_benchmark/update", this.strategyBenchmarkMasterData[0], function (error, response) {
                console.log(">>>> post data:", response);
                if (response.responseType === "success") {
                    self.$toastr.success(response.msg, "", {});
                }
            });
        }, */
        //Conversations Form : START
        /* getConversationsFormData() {
            let self = this;
            if (this.selectedStrategyTitleItem == null || this.selectedCategoryItem == null) {
                self.$toastr.error("Please select Strategy Title and Category form list", "", {});
                return;
            }

            const data = { 'strategy_category': this.selectedCategoryItem.strategy_category, 'strategy_title': this.selectedStrategyTitleItem.strategy_title };

            http.post("/frontend/strategy_question/get?type=super_admin", data, (error, response) => {
                if (response.status === 'success') {

                    if (response.data.length === 0) {
                        self.strategyQueObject = {
                            "strategy_category": this.selectedCategoryItem != null ? this.selectedCategoryItem.strategy_category : "",
                            "strategy_title": this.selectedStrategyTitleItem != null ? this.selectedStrategyTitleItem.strategy_title : "",
                            "data": []
                        };
                    } else {
                        self.strategyQueObject = response.data[0];
                    }
                }
            });
        },
        updateConversationsFormData() {
            let self = this;
            http.post("frontend/strategy_question/update", this.strategyQueObject, function (error, response) {
                console.log(">>>> post data:", response);
                if (response.responseType === "success") {
                    self.$toastr.success(response.msg, "", {});
                }
            });
        }, */
        //Conversations Form : END
        /* editStrategyMasterDataClick(param) {
            this.editStrategyMasterData = param;
            this.isNew = false;
            this.isShow = true;
            console.log("editQuery param", param);
        }, */
        getInvestorRiskProfiling() {
            let self = this;
            http.get("/frontend/portfolio_allocation_fields_for_reference/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.investorRiskProfilingMasterData = response.data;
                    //self.getStrategyData();
                }
            });
        },
        submitInvestorRiskProfilingMasterData() {
            let self = this;
            const obj = this.editInvestorRiskProfilingMasterData;
            if (obj.behavioral_loss_tolerance === "" || obj.behavioral_loss_tolerance == null || obj.risk_need === "" || obj.risk_need == null || obj.risk_taking_ability === "" || obj.risk_taking_ability == null || obj.green_yellow_red_light === "" || obj.green_yellow_red_light == null || obj.recommendation.trim() === "" || obj.strategy.trim() === "") {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitInvestorRiskProfilingMasterData >>> ', obj);
                http.post("/frontend/portfolio_allocation_fields_for_reference/update", obj, function (error, response) {
                    console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getInvestorRiskProfiling();
                    }
                    self.editInvestorRiskProfilingMasterData = {
                        "behavioral_loss_tolerance": null,
                        "risk_need": null,
                        "risk_taking_ability": null,
                        "green_yellow_red_light": null,
                        "recommendation": "",
                        "strategy": ""
                    };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        /* getFirstInvestmentAPI() {
            let self = this;
            http.get("/frontend/experience_since_your_first_investment_form/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.firstInvestmentTblData = response.data;
                }
            });
        },
        submitFirstInvestmentAPI() {
            let self = this;
            const obj = this.firstInvestmentTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                if (item.financial_instrument_type == "" || item.product_knowledge == "" || item.product_knowledge == null) {
                    notValid = true;
                }
            });
            
            if (notValid) {
                this.$toastr.error("Please fill the 'Financial instrument type' and 'Product knowledge' form proper !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitFirstInvestmentAPI >>> ', obj[0]);
                http.post("/frontend/experience_since_your_first_investment_form/update", obj[0], function (error, response) {
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getFirstInvestmentAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addFirstInvestmentData() {
            this.firstInvestmentTblData[0].data.push({
                "financial_instrument_type": "",
                "product_knowledge": null,
                "date_of_first_investment": "",
                "invested_amount_INR_cr": "",
                "mumber_of_transactions": ""
            });
        },
        */
        /* interpretation Result :START */
        /* getInterpretationResultAPI() {
            let self = this;
            http.get("/frontend/interpretation_of_results/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.interpretationResultTblData = response.data;
                    //self.getStrategyData();
                }
            });
        },
        submitInterpretationResultAPI() {
            let self = this;
            const obj = this.interpretationResultTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item['score '] == "" || item.risk_tolerance == "" || item.client_classification == "" || item.type_of_product == "" || item.descriptions == "") {
                    notValid = true;
                }
            });
            //console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitInterpretationResultAPI >>> ', obj[0]);
                http.post("/frontend/interpretation_of_results/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getInterpretationResultAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addInterpretationResultData() {
            this.interpretationResultTblData[0].data.push({
                "score ": "",
                "risk_tolerance": "",
                "client_classification": "",
                "type_of_product": "",
                "descriptions": ""
            });
        },
        removeInterpretationResultData(idx) {
            this.interpretationResultTblData[0].data.splice(idx, 1);
        }, */
        /* interpretation Result :END */

        /* AAA FrameworkAPI : START */
        /* getAAAFrameworkAPI() {
            let self = this;
            http.get("/frontend/assumptions_asset_allocation_framework/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaFrameworkTblData = response.data;
                }
            });
        },
        submitAAAFrameworkAPI() {
            let self = this;
            const obj = this.aaaFrameworkTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.S_No == "" || item.Assumption == "") {
                    notValid = true;
                }
                item.data.map((childItem) => {
                    if (childItem.sub_category == "") {
                        notValid = true;
                    }
                });
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAAFrameworkAPI >>> ', obj[0]);
                http.post("/frontend/assumptions_asset_allocation_framework/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAAFrameworkAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAAAFrameworkData() {
            this.aaaFrameworkTblData[0].data.push({
                "S_No": this.aaaFrameworkTblData[0].data.length + 1,
                "Assumption": "",
                "data": [
                    {
                        "sub_category": "",
                        "input_value": ""
                    }
                ]
            });
        },
        removeAAAFrameworkData(idx) {
            this.aaaFrameworkTblData[0].data.splice(idx, 1);
        }, */
        /* addSubCategoryData(parent) {
            parent.push({
                "sub_category": "",
                "input_value": ""
            });
        },
        removeSubCategoryData(parent, idx) {
            parent.splice(idx, 1);
        }, */
        /* AAA FrameworkAPI : END */

        /* Calculation Limit : START */
        getCalculationLimitAPI() {
            let self = this;
            http.get("/frontend/portfolio_allocation_calculation_limit_from/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.calculationLimitTblData = response.data;
                }
            });
        },
        submitCalculationLimitAPI() {
            let self = this;
            const obj = this.calculationLimitTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
                if (item.risk_limits == "" || item.low == "" || item.mod_low == "" || item.moderate == "" || item.mod_high == "" || item.high == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                //console.log('submitCalculationLimitAPI >>> ', obj[0]);
                //return;
                http.post("/frontend/portfolio_allocation_calculation_limit_from/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getCalculationLimitAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addCalculationLimitData() {
            this.calculationLimitTblData[0].data.push({
                "risk_limits": "",
                "low": "",
                "mod_low": "",
                "moderate": "",
                "mod_high": "",
                "high": ""
            });
        },
        removeCalculationLimitData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.calculationLimitTblData[0].data.splice(idx, 1);
                self.submitCalculationLimitAPI();
            }
        },
        /* Calculation Limit : END */

        /*----------------------------------*/
        /* Desired Mix Alternatives : START */
        /*----------------------------------*/
        getDesiredMixAlternativesAPI() {
            let self = this;
            http.get("/frontend/desired_alternatives_allocation_client/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.desiredMixAlternativesTblData = response.data;
                }
            });
        },
        submitDesiredMixAlternativesAPI() {

            let self = this;
            const obj = this.desiredMixAlternativesTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
                if (item.desired_asset_field == "" || item['%_Mix'] == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submit >>> ', obj[0]);
                //return;
                http.post("/frontend/desired_alternatives_allocation_client/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getDesiredMixAlternativesAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addDesiredMixAlternativesData() {
            this.desiredMixAlternativesTblData[0].data.push({
                "desired_asset_field": "",
                "%_Mix": ""
            });
        },
        removeDesiredMixAlternativesData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.desiredMixAlternativesTblData[0].data.splice(idx, 1);
                self.submitDesiredMixAlternativesAPI();
            }
        },
        /*--------------------------------*/
        /* Desired Mix Alternatives : END */
        /*-------------------------------*/


        /***********************************/
        /* Desire Asset Allocation : START */
        /***********************************/
        getDesireAssetAllocationAPI() {
            let self = this;
            http.get("/frontend/desired_asset_allocation_client/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.desireAssetAllocationTblData = response.data;
                }
            });
        },
        submitDesireAssetAllocationAPI() {
            let self = this;
            const obj = this.desireAssetAllocationTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
                if (item.desired_asset_field == "" || item['%_Mix'] == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submit >>> ', obj[0]);
                //return;
                http.post("/frontend/desired_asset_allocation_client/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getDesireAssetAllocationAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        //addCalculationLimitData() {
        addDesireAssetAllocationData() {
            this.desireAssetAllocationTblData[0].data.push({
                "desired_asset_field": "",
                "%_Mix": ""
            });
        },
        //removeCalculationLimitData(idx) {
        removeDesireAssetAllocationData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.desireAssetAllocationTblData[0].data.splice(idx, 1);
                self.submitDesireAssetAllocationAPI();
            }
        },
        /********************************/
        /* Desire Asset Allocation : END */
        /********************************/

        /* Portfolio Allocation Asset Class : START */
        getAssetClassAPI() {
            let self = this;
            http.get("/frontend/portfolio_allocation_asset_class/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.assetClassTblData = response.data;
                }
            });
        },
        submitAssetClassAPI() {
            let self = this;
            const obj = this.assetClassTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
                if (item.asset_class_field == "" || item.INR == "" || item.persentage == "" || item.investment_horizon_years == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            /* if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            } */

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                //console.log('submitCalculationLimitAPI >>> ', obj[0]);
                //return;
                http.post("/frontend/portfolio_allocation_asset_class/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAssetClassAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAssetClassData() {
            this.assetClassTblData[0].data.push({
                "asset_class_field": "",
                "INR": "",
                "persentage": "",
                "investment_horizon_years": ""
            });
        },
        removeAssetClassData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.assetClassTblData[0].data.splice(idx, 1);
                self.submitAssetClassAPI();
            }
        },
        /* Portfolio Allocation Asset Class : END */

        /* Outlook and Action  : START */
        getOutlookAndActionAPI() {
            let self = this;

            http.get("/frontend/profile_allocation_asset_class_outlook_and_action/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.outlookAndActionTblData = response.data;
                }
            });
        },
        submitOutlookAndActionAPI() {
            let self = this;
            const obj = this.outlookAndActionTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
                if (item.field_name == "" || item.outlook == "" || item.action == "" || item.rationale == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitOutlookAndActionAPI >>> ', obj[0]);
                //return;
                http.post("/frontend/profile_allocation_asset_class_outlook_and_action/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getOutlookAndActionAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addOutlookAndActionData() {
            this.outlookAndActionTblData[0].data.push({
                "field_name": "",
                "outlook": "",
                "action": "",
                "rationale": ""
            });
        },
        removeOutlookAndActionData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.outlookAndActionTblData[0].data.splice(idx, 1);
                self.submitOutlookAndActionAPI();
            }
        },
        /* Outlook and Action : END */


        /* Hybrid Bifurcation  : START */
        getHybridBifurcationAPI() {
            let self = this;

            http.get("/frontend/hybrid_bifurcation_table/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.hybridBifurcationTblData = response.data;
                }
            });
        },
        submitHybridBifurcationAPI() {
            let self = this;
            const obj = this.hybridBifurcationTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
                if (item.field_name.trim() == "" || item.value.trim() == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submit >>> ', obj[0]);
                //return;
                http.post("/frontend/hybrid_bifurcation_table/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getHybridBifurcationAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addHybridBifurcationData() {
            this.hybridBifurcationTblData[0].data.push({
                "field_name": "",
                "value": ""
            });
        },
        removeHybridBifurcationData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.hybridBifurcationTblData[0].data.splice(idx, 1);
                self.submitHybridBifurcationAPI();
            }
        },
        /* Hybrid Bifurcation : END */


        /* Alternatives- INR : START */
        getAlternativesInrAPI() {
            let self = this;

            http.get("/frontend/portfolio_allocation_alternatives/get", {}, (error, response) => {
                if (response.status === 'success') {
                    //self.hybridBifurcationTblData = response.data;
                    self.allocationAlternativesInrTblData = response.data;

                }
            });
        },
        submitAlternativesInrAPI(flg = false) {
            let self = this;
            const obj = this.allocationAlternativesInrTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
                if (item.asset_class_field.trim() == "" || item.INR.trim() == "" || item.persentage.trim() == "") {
                    notValid = true;
                }
            });
            console.log('flg', flg);
            if (flg === true) {
                notValid = false;
            }
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submit >>> ', obj[0]);
                //return;
                http.post("/frontend/portfolio_allocation_alternatives/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAlternativesInrAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAlternativesInrData() {
            this.allocationAlternativesInrTblData[0].data.push({
                "asset_class_field": "",
                "INR": "",
                "persentage": ""
            });
        },
        removeAlternativesInrData(idx) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                self.allocationAlternativesInrTblData[0].data.splice(idx, 1);
                self.submitAlternativesInrAPI(true);
            }
        },
        /* Alternatives-INR : END */

        /* AAA Time-Horizon-Based : START */
        /* getAAATimeHorizonAPI() {
            let self = this;
            http.get("/frontend/assest_allocation_assumptions_time_horizon_based/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaTimeHorizonTblData = response.data;
                }
            });
        },
        submitAAATimeHorizonAPI() {
            let self = this;
            const obj = this.aaaTimeHorizonTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.Category == "" || item.Description == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAATimeHorizonAPI >>> ', obj[0]);
                //return;
                http.post("/frontend/assest_allocation_assumptions_time_horizon_based/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAATimeHorizonAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAAATimeHorizonData() {
            this.aaaTimeHorizonTblData[0].data.push({
                "S_No": this.aaaTimeHorizonTblData[0].data.length + 1,
                "Category": "",
                "Description": "",
                "Liquid": "",
                "Debt": "",
                "Gold": "",
                "Equity": "",
                "Total": 0,
                "Portfolio_Returns": 0
            });
        },
        removeAAATimeHorizonData(idx) {
            this.aaaTimeHorizonTblData[0].data.splice(idx, 1);
        }, */
        /* AAA Time-Horizon-Based : END */

        /* AAA Based-on-Risk-Profile-of-Client : START */
        /* getAAARiskProfileOfClientAPI() {
            let self = this;
            http.get("/frontend/asset_allocation_assumption_risk_profile_client_based/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaRiskProfileOfClientTblData = response.data;
                }
            });
        },
        submitAAARiskProfileOfClientAPI() {
            let self = this;
            const obj = this.aaaRiskProfileOfClientTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.Type_of_Investor == "" || item.Risk_Profile == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAARiskProfileOfClientAPI >>> ', obj[0]);
                //return;  
                http.post("/frontend/asset_allocation_assumption_risk_profile_client_based/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAARiskProfileOfClientAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAAARiskProfileOfClientData() {
            this.aaaRiskProfileOfClientTblData[0].data.push({
                "S_No": this.aaaRiskProfileOfClientTblData[0].data.length + 1,
                "Type_of_Investor": "",
                "Risk_Profile": "",
                "Liquid": "",
                "Debt": "",
                "Gold": "",
                "Equity": "",
                "Total": 0,
                "Portfolio_Returns": 0
            });
        },
        removeAAARiskProfileOfClientData(idx) {
            this.aaaRiskProfileOfClientTblData[0].data.splice(idx, 1);
        }, */
        /* AAA Based-on-Risk-Profile-of-Client : END */

        /* AAA Income Generation Requirement : START */
        /* getAAAIncomeGenerationAPI() {
            let self = this;
            http.get("/frontend/asset_allocation_assumptions_income_generation/get", {}, (error, response) => {
                if (response.status === 'success') {
                    self.aaaIncomeGenerationTblData = response.data;
                }
            });
        },
        submitAAAIncomeGenerationAPI() {
            let self = this;
            const obj = this.aaaIncomeGenerationTblData;
            let notValid = false;
            obj[0].data.map((item) => {
                //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)
                if (item.Type_of_Corpus == "" || item.When == "") {
                    notValid = true;
                }
            });
            console.log('notValid:', notValid);
            if (notValid) {
                this.$toastr.error("All form fields filled required !", "", {});
                return;
            }

            if (obj.length === 0) {
                this.$toastr.error("All fields filled required.", "", {});
            } else {
                console.log('submitAAARiskProfileOfClientAPI >>> ', obj[0]);
                //return;  
                http.post("/frontend/asset_allocation_assumptions_income_generation/update", obj[0], function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getAAAIncomeGenerationAPI();
                    }
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        addAAAIncomeGenerationData() {
            this.aaaIncomeGenerationTblData[0].data.push({
                "S_No": this.aaaIncomeGenerationTblData[0].data.length + 1,
                "Type_of_Corpus": "",
                "When": "",
                "Liquid": "",
                "Debt": "",
                "Gold": "",
                "Equity": "",
                "Total": 0,
                "Portfolio_Returns": 0
            });
        },

        removeAAAIncomeGenerationData(idx) {
            this.aaaIncomeGenerationTblData[0].data.splice(idx, 1);
        }, */
        /* AAA Income Generation Requirement : END */

        showNewStrategy() {
            this.editStrategyMasterData = { strategy_title: "" };
            this.isNew = true;
            this.isShow = true;
        },

        showNewInvestorProfilingMasterData() {
            this.editInvestorRiskProfilingMasterData = {
                "behavioral_loss_tolerance": null,
                "risk_need": null,
                "risk_taking_ability": null,
                "green_yellow_red_light": null,
                "recommendation": "",
                "strategy": ""
            };
            this.isNew = true;
            this.isShow = true;
        },

        editInvestorRiskProfilingMasterClick(param) {
            console.log('param', param);
            this.editInvestorRiskProfilingMasterData = param;
            this.isNew = false;
            this.isShow = true;
            console.log("editQuery param", param);
        },
        removeInvestorRiskProfilingMasterClick(field) {
            let self = this;
            console.log('removeInvestorRiskProfilingMaster: ', field)
            //return;
            if (confirm("Are you sure you want to delete this item?") == true) {
                const param = { "_id": field._id };
                console.log('param', param);
                http.post("frontend/portfolio_allocation_fields_for_reference/delete", param, function (error, response) {
                    console.log('removeInvestorRiskProfilingMaster/delete: ', response);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getInvestorRiskProfiling();
                    }
                });
            }
        },
        submit() {
            this.$validate(["firstname", "email"]).then(success => {

            });
        },
        getTabData(tabIndex, newTab, oldTab) {
            console.log('Tab:', tabIndex, newTab.title, oldTab.title);
            /* Strategy
            Category
            Strategy Benchmark
            Strategy Form
            Conversations Form */
            if (newTab.title === 'Strategy') {
                //this.getStrategyMasterData();
                //this.retirementFormDataCollection = Array.from(this.retirementFormData);
                //this.retirementFormDataCollection = [...this.retirementFormData];
            } else if (newTab.title === 'Category') {
                //this.getCategoryMasterData();
            } else if (newTab.title === 'Response Title') {
                //this.getResponseTitleMasterData();
            } else if (newTab.title === 'Question Type') {
                //this.getQuestionTypeMasterData();
            } else if (newTab.title === 'Strategy Benchmark') {
                this.getStrategyBenchmarkMasterData();
            } else if (newTab.title === 'Strategy Form') {
                //this.getStrategyData();
            } else if (newTab.title === 'Conversations Form') {
                this.selectedStrategyTitleItem = null;
                this.selectedCategoryItem = null;
                this.strategyQueObject = {
                    "strategy_category": "",
                    "strategy_title": "",
                    "data": []
                };
            } else if (newTab.title === 'Risk Profiling') {
                this.getInvestorRiskProfiling();
            } else if (newTab.title === 'Portfolio Allocation Calculation Limit') {
                this.getCalculationLimitAPI();
            } else if (newTab.title === 'Desired Asset Allocation (Client)') {
                this.getDesireAssetAllocationAPI();
            } else if (newTab.title === 'Alternatives Desired Mix') {
                this.getDesiredMixAlternativesAPI();
            } else if (newTab.title === 'Portfolio Allocation Asset Class') {
                this.getAssetClassAPI();
            } else if (newTab.title === 'Asset Class Outlook And Action') {
                this.getOutlookAndActionAPI();
            } else if (newTab.title === 'Hybrid Bifurcation') {
                this.getHybridBifurcationAPI();
            } else if (newTab.title === 'Portfolio Allocation Alternatives-INR') {
                this.getAlternativesInrAPI();
            }

            this.isNew = false;
            this.isShow = false;
        },
    },
    /* validators: {
      email: function (value) {
        return Validator.value(value).required().email();
      }
    } */
    validators: {
        title: function (value) {
            return Validator.value(value).required();
        },
        type: function (value) {
            return Validator.value(value).required();
        },
        strategy_benchmark: function (value) {
            return Validator.value(value).required();
        },
    },
};
</script>
<style>
.txt-fmt {
    font-size: small;
}

.form-cs {
    border: 1px solid #c4c2c2;
    padding: 13px;
    padding-bottom: 0;
    border-radius: 7px;
    background-color: #f5faff;
}

.strategy-edit {
    background-color: #d3ebef;
    border-radius: 5px;
    margin: 1rem;
}

.v-select {
    width: 100%;
    margin-left: 0px;
}

#strategyBenchmark .v-select {
    width: 100%;
    margin-left: 0;
}

#conversationForm .v-select {
    width: 100%;
    margin-left: 0;
}

#investorRiskProfiling .v-select {
    width: 100%;
    margin-left: 0 !important;
}

.v-select .dropdown-toggle {
    background-color: white;
    padding: 0 0 6px;
}

.sel-tag-main {
    width: 100%;
    /* margin-left: 10px; */
    appearance: none;
    display: flex;
    padding: 0 0 4px;
    background: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
    flex-wrap: wrap;
}

.selected-tag {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    color: #333;
    line-height: 1.42857143;
    margin: 4px 2px 0;
    padding: 0 .25em;
    transition: opacity .25s;
}

.error {
    color: red;
    /* border: 1px solid red; */
}

.txt-area {
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    width: 100%;
}

.new-cal-2 {
    max-width: 14% !important;
    min-width: 14% !important;
}

.dropdown-menu {
    font-size: small;
}

.new-tbl-cs {
    appearance: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
    height: 1.5rem;
    width: 100%;
    height: 1.9rem;
    padding: 0 6px;
}

.new-tbl-aaa-cs {
    appearance: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
    height: 1.5rem;
    width: 100%;
    height: 1.9rem;
    padding: 0 6px;
    margin: 3px 0 3px;
}



.table td {
    padding: 5px 7px 5px 7px;
}

.circle-btn {
    /* position: relative; */
    /* padding: 30px !important; */
    /* background-color: var(--accent); */
    border-radius: 100%;
    width: fit-content;
    border: none;
    margin-left: 0.5rem;
}

/* .pull-right{
    display: flex;
} */
</style>


// WEBPACK FOOTER //
// src/views/acl/profiling/profiling-allocation-form.vue